<template>
  <WdsStack direction-column gap-md class="contact-details-fields">
    <WdsInput
      :model-value="name ?? ''"
      :placeholder="$t('Full name')"
      data-test="contact-name"
      @update:model-value="$emit('update:name', String($event ?? ''))"
    >
      <template #label>
        {{ $t('Contact name') }}
        <span v-if="required" class="tw-text-indigo-500 tw-font-bold">*</span>
      </template>
    </WdsInput>

    <WdsInput
      :model-value="email ?? ''"
      :placeholder="$t('name@company.com')"
      data-test="contact-email"
      @update:model-value="$emit('update:email', String($event ?? ''))"
    >
      <template #label>
        {{ $t('Contact email') }}
        <span v-if="required" class="tw-text-indigo-500 tw-font-bold">*</span>
      </template>
    </WdsInput>

    <div>
      <WdsText primary class="tw-mb-1 tw-block">
        {{ $t('Contact phone') }}
        <span v-if="required" class="tw-text-indigo-500 tw-font-bold">*</span>
      </WdsText>
      <InputTelephone
        :persistent-phone-number="phone ?? ''"
        :show-verify-button="false"
        :placeholder="$t('+45 12 34 56 78')"
        data-test="contact-phone"
        @phone-changed="(value) => $emit('update:phone', value ?? '')"
      />
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsText, WdsInput } from '@worksome/wds-components'
import InputTelephone from '@/components/InputTelephone.vue'
import { $t } from '@/composables/translation'

withDefaults(
  defineProps<{
    name?: string | null
    email?: string | null
    phone?: string | null
    required?: boolean
  }>(),
  { name: '', email: '', phone: '', required: false },
)

defineEmits<{
  'update:name': [value: string]
  'update:email': [value: string]
  'update:phone': [value: string]
}>()
</script>
